import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type RecoveryPlan } from '../../api/resilience';

export function RecoveryCenterPage() {
  const [plans, setPlans] = useState<RecoveryPlan[]>([]);
  const [drillResult, setDrillResult] = useState<string | null>(null);
  useEffect(() => { void resilienceApi.listRecoveryPlans().then(setPlans); }, []);
  const runDrill = async (planId: string) => {
    const d = await resilienceApi.runDrill({ plan_id: planId });
    setDrillResult(`${d.name}: ${d.passed ? 'PASSED' : 'FAILED'} (RTO ${d.rto_achieved_seconds}s, RPO ${d.rpo_achieved_seconds}s)`);
  };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Recovery Center</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      {drillResult && <p className="mt-4 text-sm text-emerald-700 dark:text-emerald-400">{drillResult}</p>}
      <div className="mt-6 space-y-3">{plans.map((p) => (
        <div key={p.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
          <div className="flex justify-between"><span className="font-medium">{p.name}</span><button type="button" onClick={() => runDrill(p.id)} className="text-sm text-emerald-700 hover:underline dark:text-emerald-400">Run drill</button></div>
          <p className="mt-1 text-sm text-slate-500">{p.description}</p>
          <p className="mt-1 text-xs text-slate-500">RTO: {p.rto_seconds}s · RPO: {p.rpo_seconds}s · {p.automated ? 'Automated' : 'Manual'}</p>
        </div>
      ))}</div>
    </div>
  );
}
